import { createUseStyles } from 'react-jss';

import { ITheme } from '../../../../../styles';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    '@global': {
      '.NavDropdown': {
        display: 'none',
      },
      '.NavDropdownText': {
        minWidth: 260,
      },
      '.NavDropdownOther': {
        minWidth: 260,
      },
      '.NavDropdownAiWriter': {
        minWidth: 260,
      },
      '.NavDropdownImage': {
        minWidth: 700,
      },
      '.NavDropdownDesign': {
        minWidth: 200,
      },
    },

    root: {
      backgroundColor: '#fff',
      borderRadius: 16,
      boxShadow: '0px 0px 16px 0px rgba(0, 0, 0, 0.16)',
      padding: 24,
      position: 'absolute',
      top: 70,
      width: 'max-content',
    },

    left: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',

      '&.NavDropdownText': {
        minHeight: 376 - 48,
      },
      '&.NavDropdownAiWriter': {
        minHeight: 376 - 48,
      },

      '&.NavDropdownImage': {
        height: 376 - 48,

        '& $items': {
          columnGap: 20,
          display: 'grid',
          gridAutoFlow: 'column',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gridTemplateRows: 'repeat(6, 1fr)',
        },
      },
    },

    other: {
      minHeight: 'auto',
    },

    items: {
      listStyleType: 'none',
    },

    item: {
      borderRadius: 8,
      marginBlockEnd: 8,
      padding: 4,

      '&:hover': {
        backgroundColor: 'var(--x-bg-5)',
      },
    },

    menuItemText: {},

    itemContainer: {
      alignItems: 'center',
      display: 'flex',
    },

    text: {
      color: 'var(--x-text-color-5)',
      fontSize: 14,
      fontWeight: 600,
      flexGrow: 1,
      marginInline: 8,
    },

    itemSelected: {
      backgroundColor: 'var(--x-bg-5)',

      '& $menuItemText': {
        color: '#000',
      },
    },

    arrow: {
      fill: '#000',
    },
  }),
  { name: 'NavDropdown' },
);

export default useStyles;
